import { Component, Input, OnInit, HostListener, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { SessionStoreService } from '../services/session-store.service';

@Component({
    selector: 'app-select-portal',
    templateUrl: './select-portal.component.html',
    styleUrls: ['./select-portal.component.scss'],
    standalone: false
})
export class SelectPortalComponent implements OnInit {
  @Input() portals: any[] = [];
  selectedPortal: any = null;
  searchText: string = '';
  isOpen: boolean = false;

  constructor(
    private router: Router,
    private elRef: ElementRef,
    private sessionStore: SessionStoreService
  ) {}

  ngOnInit(): void {}

  get filteredPortals(): any[] {
    const q = this.searchText.trim().toLowerCase();
    if (!q) return this.portals;
    return this.portals.filter(p => p.name.toLowerCase().includes(q));
  }

  get displayValue(): string {
    if (this.isOpen) return this.searchText;
    return this.selectedPortal ? this.selectedPortal.name : '';
  }

  openDropdown(): void {
    this.isOpen = true;
    this.searchText = '';
  }

  selectPortal(portal: any): void {
    this.selectedPortal = portal;
    this.searchText = '';
    this.isOpen = false;
  }

  onInputChange(value: string): void {
    this.searchText = value;
    if (!this.isOpen) this.isOpen = true;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!this.elRef.nativeElement.contains(event.target)) {
      this.isOpen = false;
      this.searchText = '';
    }
  }

  enterPortal(): void {
    if (!this.selectedPortal) return;
    this.sessionStore.setSesion(this.selectedPortal.sesion);
    this.sessionStore.setActivePortalId(this.selectedPortal.id.toString());
    this.router.navigateByUrl('/my-portals');
  }
}
